// core version + navigation, pagination modules:
import Swiper from 'swiper/bundle';

var slider_featured = new Swiper(".slider-featured", {
  lazy: true,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  breakpoints: {
    '0': {
      slidesPerView: "auto",
      //spaceBetween: 30,
      //loop: true,
    },
    '992': {
      slidesPerView: 2,
      spaceBetween: 30
    }
  }
});

var slider_promo = new Swiper(".slider-promo-container .slider-promo", {
  lazy: true,
  slidesPerView: 1,
  loop: true,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  navigation: {
    prevEl: ".slider-promo-container .btn-slider-prev",
    nextEl: ".slider-promo-container .btn-slider-next",
  },
});